// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"d4d6b1b1","102":"2fee4830","207":"315ea159","390":"780e8915","453":"790ab78f","558":"077839ae","790":"5316dbf6","875":"fc5a1422","896":"20feba20"}[chunkId] + ".chunk.js";
};